(() => {
  const makeStatus = (text, state) => {
    const badge = document.createElement('span');
    badge.className = `sh-support-status sh-support-status--${state}`;
    badge.textContent = text;
    return badge;
  };

  const addStatus = (container, text, state) => {
    if (!container || container.querySelector(':scope > .sh-support-status')) return;
    container.appendChild(makeStatus(text, state));
  };

  const deactivateRequest = (link) => {
    if (!link || link.dataset.supportInactive === 'true') return;
    link.dataset.supportInactive = 'true';
    link.classList.add('ss-request--inactive');
    link.removeAttribute('href');
    link.setAttribute('aria-disabled', 'true');
    link.setAttribute('tabindex', '-1');
    addStatus(link, 'NOT YET ACTIVATED', 'inactive');
    const action = link.querySelector('.ss-request__action');
    if (action) action.textContent = 'REQUESTS CLOSED · NOT YET ACTIVATED';
    link.addEventListener('click', (event) => event.preventDefault());
  };

  const enhanceImpactArchive = () => {
    const page = document.querySelector('.ss-page');
    if (!page || page.dataset.parentWishEnhanced === 'true') return;

    const cycleGrid = page.querySelector('.ss-cards');
    const requestGrid = page.querySelector('.ss-request-grid');
    if (!cycleGrid || !requestGrid) return;

    page.dataset.parentWishEnhanced = 'true';

    const protocolTitle = page.querySelector('#ss-protocol-title');
    if (protocolTitle) protocolTitle.innerHTML = 'THREE CYCLES.<br>ONE PROMISE.';

    const existingCycles = [...cycleGrid.querySelectorAll(':scope > .ss-card')];
    existingCycles.forEach((card) => {
      card.classList.add('ss-card--inactive');
      addStatus(card, 'NOT YET ACTIVATED', 'inactive');
    });

    [...requestGrid.querySelectorAll('a[href="/pages/request-dog-support"], a[href="/pages/request-human-support"]')].forEach(deactivateRequest);

    const cycle = document.createElement('article');
    cycle.className = 'ss-card ss-card--parent ss-card--active';
    cycle.innerHTML = `
      <span class="sh-support-status sh-support-status--active">ACTIVE CHAPTER</span>
      <div class="ss-ratio"><b>01</b><span>/</span><span>200</span></div>
      <p class="ss-kicker ss-card__label">DELIVERED ORDERS / PARENT WISH</p>
      <h3>FOR THE ONES<br>WHO RAISED US.</h3>
      <p class="ss-card__copy">For every 200 successfully delivered orders, SurvivingHuman will review and fulfil one verified, meaningful wish for an eligible customer's mother or father—handled with dignity, consent and clear documentation.</p>`;
    cycleGrid.appendChild(cycle);

    const closingTitle = page.querySelector('.ss-closing .ss-title');
    if (closingTitle) closingTitle.innerHTML = 'ONE OPEN DOORWAY.<br>ONE STANDARD:<br><em>DIGNITY FIRST.</em>';

    const request = document.createElement('a');
    request.className = 'ss-request ss-request--parent ss-request--active';
    request.href = '/pages/request-parent-wish';
    request.setAttribute('aria-label', 'Open the active 1 in 200 Parent Wish request');
    request.innerHTML = `
      <span class="sh-support-status sh-support-status--active">REQUESTS OPEN</span>
      <span class="ss-request__ratio">01 / 200 · PARENT WISH</span>
      <h3>FULFIL A WISH<br>FOR THEM.</h3>
      <p>Eligible customers can submit one meaningful wish for their mother or father during the active cycle.</p>
      <span class="ss-request__action">OPEN ACTIVE PARENT WISH REQUEST <i class="ss-request__arrow" aria-hidden="true">→</i></span>`;
    requestGrid.appendChild(request);
  };

  const enhanceRequestStatus = () => {
    const inactiveRoot = document.querySelector('.hr-request, .sr-request--dog');
    if (inactiveRoot) {
      inactiveRoot.classList.add('sh-support-program--inactive');
      const meta = inactiveRoot.querySelector('.hr-request__meta, .sr-request__meta');
      addStatus(meta, 'NOT YET ACTIVATED · REQUESTS CLOSED', 'inactive');
    }

    const parentRoot = document.querySelector('.pw-request');
    if (parentRoot) {
      parentRoot.classList.add('sh-support-program--active');
      const meta = parentRoot.querySelector('.pw-request__meta');
      addStatus(meta, 'ACTIVE CHAPTER · REQUESTS OPEN', 'active');

      const labelParentWishFields = () => {
        document.querySelectorAll('.pw-field-label').forEach((label, index) => {
          const control = label.nextElementSibling;
          if (!control || !/^(INPUT|SELECT|TEXTAREA)$/.test(control.tagName)) return;
          if (!control.id) control.id = `ParentWishField-${index + 1}`;
          label.htmlFor = control.id;
        });
      };
      labelParentWishFields();
      requestAnimationFrame(labelParentWishFields);
      setTimeout(labelParentWishFields, 0);

      document.querySelectorAll('h1:not(#pw-title)').forEach((heading) => {
        if (heading.offsetParent !== null) return;
        heading.setAttribute('aria-hidden', 'true');
        heading.setAttribute('role', 'presentation');
      });
    }

    document.querySelectorAll('a[href="/pages/request-dog-support"], a[href="/pages/request-human-support"]').forEach(deactivateRequest);
  };

  const init = () => {
    enhanceImpactArchive();
    enhanceRequestStatus();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
